// @ts-nocheck
import { getFiltersApplied, getRedirectURL, openBookForm } from "@Components/LeadForm/utils";
import config from "@Config/index";
import { getAvailableStartingPricingHelper } from "@Pages/Search/components/SearchListItem/helper";
import gtagEventEmitter, { gtagDuplicateEventEmitter } from "helpers/gtagEventEmitter";
import uetEventEmitter, { uetEventEmitterForChina } from "helpers/uetEventEmitter";
import { createLead } from "services/leadsHelper";
import { countryCodes } from "@Components/LeadFormModal/data/countryCodes";
import {
  BOOKFORM_SOURCE_MAP,
  CTA_SOURCE_MAPPING,
  LEAD_SOURCE_MAPPING,
} from "@Components/LeadFormV2/constants";
import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";
import { createVirtualTourRequest } from "services/virtualTourHelper";
import { convertToWhitelabelURL } from "@Pages/WhitelabelHome/Desktop/helpers/WhiteLabelRedirectionHelper";
import urlBuilder from "@Utils/urlBuilder";
import { isHappyFlowForUSA } from "@Components/LeadFormV2/utils";
import { logAppEvent, logMetaEvent } from "@Utils/appAnalytics";
import getCookie from "helpers/getCookie";
import { getPricingCurrencyStandardName } from "@Pages/PropertyPage/components/RoomTypeSection/utils";
import { META_EVENT_CONSTANTS } from "constants/index";
import { APP_EVENTS, getAppSourceDetails } from "@Utils/webApputils/analyticEvents";
import getUserIpAddress from "@Utils/getUserIpAddress";
import { detectIframeContext, getIframeSource } from "@Utils/iframeContext";
import { getIframeEventData, clearIframeEventData } from "@Utils/iframeEventData";
import currencyData from "constants/currencyConstants";
import AmberLocalStorage from "@Utils/AmberlocalStorage";
import { getRecordedPropertyNameForPostHog, identifyPostHogUserByEmail } from "@Utils/posthog";
import getFCMToken from "@Utils/fcmTokenStorage";
import { isApp } from "hooks/useIsApp";
import { publishWebState } from "@Utils/webApputils/nativeStateBridge";

export const onSubmitLeadFormOne = ({
  data,
  inventory = {},
  isLeadFormFilled,
  inModal,
  redirectCB,
  inventoryRegion,
  openingSource,
  isHappyFlow,
  additionalData, // for happy flow contact us form
  isOptIn,
  filters = {},
  history,
  // isDesktop,
  isPartner = false,
  shouldReturnToBookFrom = false,
  fromSearchRegionPage = false,
  referDetails = null,
  isPaymentBeforeBookform = false,
  isZendeskFlowAfterLead = false,
  isWhitelabel = false,
  partner_uuid = "",
  isDemoSubdomain = false,
  idpFormData,
  isBookFormEnabledForInactiveProperty,
  leadCustomFormData,
}: any) => {
  const codeWithCountry = countryCodes.find((code) => code.label === data.code);
  const userData = {
    "user_details/name": data.fullName,
    "user_details/email": data.email,
    "user_details/phone_code": codeWithCountry?.label,
    "user_details/phone": +data.mobileNumber,
    preferred_communication_modes: data.preferredCommunicationModes,
    university: data.university,
  };
  if (isPartner) {
    userData.intake = data?.intake?.value;
    userData.region = data.region;
  }
  if (fromSearchRegionPage) {
    userData.region = data.region;
  }

  let metaIdpFormData: any = {};
  if (idpFormData && Object.keys(idpFormData).length > 0) {
    metaIdpFormData = {
      councellor_name: idpFormData?.councellorName,
      councellor_email: idpFormData?.councellorEmail,
      councellor_country: idpFormData?.councellorCountry,
      councellor_office: idpFormData?.councellorOffice,
    };
  }

  try {
    localStorage.setItem("lead-form-one-saved-data", JSON.stringify(userData));
    // Notify components that lead data has been saved
    window.dispatchEvent(new Event("lead-form-saved"));
  } catch (error) {
    console.error(error);
  }

  const formValues = {
    ...userData,
    ...(inventory?.region && { region: inventory?.region }),
  };

  // Lead Created Conversion for Google Ads
  // @ts-ignore
  // Removing gtag_report_conversion_5 as it is only for referral leads - @Ayush S
  // if (typeof gtag_report_conversion_5 == "function") {
  //   // @ts-ignore
  //   gtag_report_conversion_5();
  // }

  // source details

  const sourceData: any = {};
  sourceData.final_url = window.location.href;
  let referralCode = referDetails || "";

  if (window.getCookie) {
    let referrer = window.getCookie("referrer");
    let initial_referrer = window.getCookie("initial_referrer");
    const referring_domain = window.getCookie("referring_domain");
    const initial_referring_domain = window.getCookie("initial_referring_domain");
    const initial_utm_params = window.getCookie("initial_utm_params");
    if (referrer) {
      if (referrer.length > 300) {
        referrer = referrer.slice(0, 300);
      }
      sourceData["referrer"] = referrer;
    }
    if (initial_referrer) {
      if (initial_referrer.length > 300) {
        initial_referrer = initial_referrer.slice(0, 300);
      }
      sourceData["initial_referrer"] = initial_referrer;
    }
    if (referring_domain) {
      sourceData["referring_domain"] = referring_domain;
    }
    if (initial_referring_domain) {
      sourceData["initial_referring_domain"] = initial_referring_domain;
    }

    if (initial_utm_params || isWhitelabel) {
      const utmParamKeys = [
        "utm_source",
        "utm_campaign",
        "utm_content",
        "utm_medium",
        "utm_term",
        "utm_group",
        "gclid",
        "fbclid",
        "msclkid",
        "keyword",
        "wbraid",
        "gbraid",
        "bd_vid",
      ];

      // Parse cookie UTM params as fallback
      const cookieUtmObj: any = {};
      if (initial_utm_params) {
        const array = initial_utm_params.split("|");
        array.forEach((item: any) => {
          const [key, value] = item.split("=");
          if (key && value) {
            cookieUtmObj[key] = value;
          }
        });
        if (cookieUtmObj["referral_code"]) {
          referralCode = cookieUtmObj["referral_code"];
        }
      }

      // Get URL params as source of truth for partner lead form
      const urlParams = new URLSearchParams(window.location.search);

      if (isWhitelabel) {
        const storedUtmSource = AmberLocalStorage.getItem("UTM_SOURCE");
        sourceData["utm_source"] = urlParams.get("utm_source") || storedUtmSource || partner_uuid;
        sourceData["utm_medium"] = "whitelabelv2";
        sourceData["utm_campaign"] = "partner";
      } else if (isPartner) {
        // For partner lead forms: URL params take priority, cookie as fallback
        utmParamKeys.forEach((key) => {
          const urlValue = urlParams.get(key);
          if (urlValue) {
            sourceData[key] = urlValue;
          } else if (cookieUtmObj[key]) {
            sourceData[key] = cookieUtmObj[key];
          }
        });
      } else {
        // For non-partner forms: use cookie values, with localStorage override for utm_source
        const storedUtmSource = AmberLocalStorage.getItem("UTM_SOURCE");
        utmParamKeys.forEach((key) => {
          if (key === "utm_source" && storedUtmSource) {
            sourceData[key] = storedUtmSource;
          } else if (cookieUtmObj[key]) {
            sourceData[key] = cookieUtmObj[key];
          }
        });
      }
    }
  }

  let leadFormData: any = {};

  // Basic Details
  leadFormData.state = "created";
  if (Object.keys(inventory).length > 0)
    leadFormData.inventory_id = inventory.id || inventory?.config?.id;

  const phoneCode = formValues["user_details/phone_code"]?.split("+")[1];
  const phoneNumber = formValues["user_details/phone"];
  const userCurrency = getCookie("user_currency");
  // User Details
  leadFormData.user_details = {
    name: formValues["user_details/name"],
    phone: `+${phoneCode}${phoneNumber}`,
    email: formValues["user_details/email"],
  };

  // Get FCM token if in app context (to be stored in meta)
  let fcmToken = null;

  if (isApp()) {
    fcmToken = getFCMToken();
  }

  leadFormData.meta = {
    slash_pricing_flow: getCookie("slash_pricing") || "false",
    ...(openingSource === "apply_for_fall" && { is_apply_for_fall_lead: true }),
    ...(userCurrency ? { user_currency: userCurrency } : {}),
    ...(fcmToken ? { fcm_token: fcmToken } : {}),
  };

  if (leadCustomFormData?.length > 0) {
    leadFormData.lead_custom_form_data = leadCustomFormData;
  }

  const locationData =
    inventory?.region ||
    inventoryRegion ||
    (referDetails ? formValues.region : { location: inventory.location });

  const intake = data?.intake?.value;
  if (locationData) {
    const { location_place_id, location_coordinates, name, country } = locationData.location;

    const budget_duration = getDurationFromRegion(country?.long_name || name || "");
    const budget_currency = getCurrencyFromRegion(country?.long_name || name || "");
    const appliedFilters = getFiltersApplied(filters);
    const { property_view_request_details } = data;

    leadFormData = {
      ...leadFormData,
      region_id: locationData.id || inventory.region_id,
      location_place_id,
      location_place_name: name,
      location_coordinates_latitude: location_coordinates?.lat,
      location_coordinates_longitude: location_coordinates?.lng,
      data: {
        property_view_request_details,
        budget_currency,
        budget_duration,
        ...(additionalData && { ...additionalData }),
        ...(data.query && { user_query: data.query }),
        ...(data.university && { university: data.university }),
        ...appliedFilters,
      },
      meta: {
        ...leadFormData.meta,
        payment_before_bookform: Boolean(isPaymentBeforeBookform),
        lead_source: LEAD_SOURCE_MAPPING[openingSource] || "null",
        idp_form_data: metaIdpFormData,
      },
    };
  }
  // Check if form data contains location
  if (formValues.region?.location_place_id)
    leadFormData.location_place_id = formValues.region.location_place_id;

  if (formValues.region?.name) leadFormData.location_place_name = formValues.region.name;
  if (intake) leadFormData.data.intake = intake;

  // Source Details
  // get app source details
  const appSourceDetails = getAppSourceDetails();

  const ipAddress = getUserIpAddress();
  // Iframe attribution.
  const { isIframe } = detectIframeContext();
  const iframeSource = getIframeSource();
  const isIframeLead = isIframe || Boolean(iframeSource);

  leadFormData.source_details = {
    ...sourceData,
    ...appSourceDetails,
    ...(ipAddress && { ip_address: ipAddress }),
    ...(isIframeLead && { is_iframe_lead: true }),
    ...(iframeSource && { embed_source: iframeSource }),
  };

  const iframeEventData = getIframeEventData();
  if (iframeEventData && Object.keys(iframeEventData).length > 0) {
    leadFormData.meta = {
      ...leadFormData.meta,
      iframe_event_data: iframeEventData,
    };
  }
  leadFormData.event_options = {
    user_notification: isOptIn ? "true" : "false",
  };
  if (referralCode) {
    leadFormData.referral_details = {
      name: referralCode.referrerName,
      code: referralCode.referCode,
    };
  }
  leadFormData.preferred_communication_modes = formValues.preferred_communication_modes;

  // Pass agent_id from URL if present (from CRM generated links)
  if (typeof window !== "undefined") {
    const agentIdParam = new URLSearchParams(window.location.search).get("agent_id");
    if (agentIdParam) leadFormData.agent_id = agentIdParam;
  }

  // Final Data
  leadFormData = { lead: leadFormData };

  if (shouldReturnToBookFrom) return leadFormData;

  if (openingSource === "virtual_tour_request")
    return sendVirtualFormData({
      data: leadFormData,
    });

  return sendData({
    data: leadFormData,
    formValues,
    inventory,
    isLeadFormFilled,
    inModal,
    redirectCB,
    openingSource,
    isHappyFlow,
    history,
    isPartner,
    isZendeskFlowAfterLead,
    isWhitelabel,
    isDemoSubdomain,
    partner_uuid,
    isBookFormEnabledForInactiveProperty,
  });
};

const sendData = async ({
  data,
  formValues,
  inventory,
  isLeadFormFilled,
  inModal,
  redirectCB,
  openingSource,
  isHappyFlow,
  history,
  isPartner,
  isZendeskFlowAfterLead,
  isWhitelabel,
  isDemoSubdomain,
  partner_uuid,
  isBookFormEnabledForInactiveProperty,
}: any) => {
  // Emitter.emit(Events.SHOW_NANOBAR);
  // setIsLoading(true);
  const options = data;
  // if (!auth.status) {
  //   const token = await generateRecaptchaToken(executeRecaptcha, "leadFormOne");
  //   options.params = {
  //     recaptcha_token: token,
  //     recaptcha_action: "leadFormOne",
  //   };
  // }

  const response = await createLead(options);
  if (response.data) {
    localStorage.setItem("lead-form-one-success-data", JSON.stringify(response.data));
    publishWebState();
    localStorage.setItem("lead-form-submitted", "true");

    clearIframeEventData();

    if (
      formValues?.preferred_communication_modes &&
      formValues?.preferred_communication_modes.length > 0
    ) {
      localStorage.setItem("has-submitted-comm-preference", "true");
    }

    // Triggers success event to baidu(added by marketing team)
    if (config?.IS_CHINA_APP) {
      // eslint-disable-next-line no-unused-expressions
      window?._agl && window._agl.push(["track", ["success", { t: 3 }]]);
    }

    const email_id = formValues["user_details/email"];
    const phone = formValues["user_details/phone"];
    const country_code = formValues["user_details/phone_code"].split("+")[1];
    let redirectionURL = getRedirectURL({
      inventory,
      inModal,
      postSuccessData: response.data,
      formOneData: formValues,
      formTwoSavedData: {},
      // withRedirectAnimation: rest?.withRedirectAnimation || false,
      withRedirectAnimation: false,
      bookFormSource: BOOKFORM_SOURCE_MAP[openingSource],
      showSubmitConfirmation: true,
      isBookFormEnabledForInactiveProperty,
    });

    if (isWhitelabel) {
      redirectionURL = convertToWhitelabelURL(redirectionURL, isDemoSubdomain, partner_uuid);
    }

    await fireLeadFormOneSuccessEvents({
      response,
      email_id,
      phone,
      country_code,
      flag: false,
      location: inventory?.location?.locality?.long_name,
      propertyName: inventory?.name,
      inventory,
      openingSource,
      isPartner,
      preferredCommunicationModes: formValues?.preferred_communication_modes || [],
    });

    const isBookingEnable =
      inModal && (getBookingStatus(inventory) || isBookFormEnabledForInactiveProperty);
    const skipLeadFormTwo = true;
    const isFormSubmited = isLeadFormFilled === "true";

    // check for happy flow
    if (isHappyFlow) {
      if (
        openingSource === "book_now" ||
        openingSource === "clicked_book_enquire_now_property" ||
        openingSource === "search_inventory_enquire" ||
        openingSource === "clicked_gallery_book_now_button"
      ) {
        (async () => {
          await handleLeadSuccessEvents({
            email: email_id,
            phone,
            leadId: response.data?.id,
            canonicalName: inventory?.canonical_name,
            countryCode: country_code,
          });
        })();

        if (isHappyFlowForUSA(inventory, openingSource)) {
          return {
            leadFormPage: 2,
            message: "success",
            redirectionURL: getPropertyPageURL(inventory),
          };
        }

        return {
          message: "success",
          shouldClose: !isPartner && (inventory?.available || inventory?.config?.available),
          redirectionURL,
        };
      }
      return { message: "success", redirectionURL };
    }

    if (isZendeskFlowAfterLead) {
      return { showZendesk: true, message: "success", leadFormPage: 3, redirectionURL };
    }
    if (skipLeadFormTwo || isFormSubmited) {
      if (isBookingEnable) {
        // eslint-disable-next-line consistent-return
        if (
          openingSource === "get_help" ||
          openingSource === "join_waitlist" ||
          openingSource === "questions_enquiry_connect_cta" ||
          openingSource === "ask_question_faq_cta" ||
          isWhitelabel
        ) {
          return { leadFormPage: isWhitelabel ? 2 : 3, message: "success", redirectionURL };
        }

        (async () => {
          await handleLeadSuccessEvents({
            email: email_id,
            phone,
            leadId: response.data?.id,
            canonicalName: inventory?.canonical_name,
            countryCode: country_code,
          });
          if (redirectCB && !config.IS_CHINA_APP) redirectCB();
          if (!config.IS_CHINA_APP) openBookForm({ url: redirectionURL, history, target: "_self" });
        })();

        if (config.IS_CHINA_APP) {
          return { leadFormPage: 3, message: "success", redirectionURL };
        }

        return {};
      }
      // setCurrentPage(SUCCESS_PAGE);
      return { leadFormPage: isWhitelabel ? 2 : 3, message: "success", redirectionURL };
    }
    // setCurrentPage(FORM_TWO);
    if (openingSource === "join_waitlist")
      return { leadFormPage: 3, message: "success", redirectionURL };
    if (openingSource === "book_now" || openingSource === "contact_us") {
      if (redirectCB) redirectCB();
      if (!isWhitelabel) openBookForm({ url: redirectionURL, history, target: "_self" });
    }
    return { leadFormPage: 2, message: "success", redirectionURL };
  }

  if (response.error) {
    console.error(response);
    // Google Analytics
    gtagEventEmitter({ action: "failure", category: "lead" });
    gtagDuplicateEventEmitter({ action: "failure_newleadform", category: "lead" });
    if (isHappyFlow) {
      if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
        window.Sentry.captureException(`Lead Form Error -> ${response.error}`);
      }
      return { message: "failure" };
    }
    return null;
  }
  return null;

  //   .catch((err) => {
  //     console.error(err);
  //     //   if (typeof Sentry !== "undefined") {
  //     //     Sentry.captureException(new Error("lead-create-error"), {
  //     //       extra: { request: JSON.stringify(data), response: response.body },
  //     //     });
  //     //   }
  //     //   // Handle phone not proper
  //     //   if (response?.text) {
  //     //     let msg = null;
  //     //     const text = JSON.parse(response.text);
  //     //     if (text) msg = text.message;

  //     //     if (msg && msg.indexOf("phone") > -1 && msg.indexOf("not") > -1 && msg.indexOf("valid")) {
  //     //       showNotification({
  //     //         id: "2",
  //     //         title: "Incorrect phone number",
  //     //         message: "Please check your phone number and try again!",
  //     //         type: "error",
  //     //       });
  //     //     } else
  //     //       showNotification({
  //     //         id: "3",
  //     //         title: "Error while submitting",
  //     //         message: "Something went wrong! Please try later",
  //     //         type: "error",
  //     //       });
  //     //   }

  //     // Google Analytics
  //     // gtagEventEmitter({ action: "failure", category: "lead" });
  //     // gtagDuplicateEventEmitter({ action: "failure_newleadform", category: "lead" });
  //   });
};

const sendVirtualFormData = async ({ data }: any) => {
  const options = data;

  const response = await createVirtualTourRequest(options);
  if (response.data) {
    gtagEventEmitter({
      action: "clicked_virtual_tour_request_submit",
      category: "",
      lead_cta: "Submit",
    });
    return { leadFormPage: 3, message: "success" };
  }

  if (response.error) {
    console.error(response);

    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`Virtual Tour  Form Error -> ${response.error}`);
    }
    return { message: "failure" };

    return null;
  }
  return null;
};

export const stripCountryCode = (phoneCode: any, phoneNumber: any) =>
  phoneCode && phoneNumber && phoneNumber.toString().substring(0, 2) === phoneCode
    ? Number(phoneNumber.toString().substring(2))
    : phoneNumber;

export const getDurationFromRegion = (regionName: string) => {
  regionName = regionName || "";
  let duration = "monthly";
  const finalDurationObject = durationData.find((durationObject) => {
    let flag = false;
    if (durationObject.countries && durationObject.countries.length > 0) {
      durationObject.countries.forEach((country) => {
        if (regionName.toLowerCase().includes(country)) {
          flag = true;
        }
      });
    }
    return flag;
  });
  if (finalDurationObject) {
    duration = finalDurationObject.formatted;
  }
  return duration;
};

// Get currency given a region name
export const getCurrencyFromRegion = (regionName: string) => {
  regionName = regionName || "";
  let currency = "dollar";
  const finalCurrencyObject = currencyData.find((currencyObject) => {
    let flag = false;
    if (currencyObject.countries && currencyObject.countries.length > 0) {
      currencyObject.countries.forEach((country) => {
        if (regionName.toLowerCase().includes(country)) {
          flag = true;
        }
      });
    }
    return flag;
  });
  if (finalCurrencyObject) {
    currency = finalCurrencyObject.short_name;
  }
  return currency;
};

export const durationData = [
  {
    short_name: "week",
    full_name: "week",
    formatted: "weekly",
    countries: ["united kingdom", "uk", "australia", "france", "ireland"],
  },
  {
    short_name: "mo",
    full_name: "month",
    formatted: "monthly",
    countries: ["united states", "usa", "singapore", "canada", "germany"],
  },
];

// eslint-disable-next-line consistent-return
export const getBookingStatus = (inventory: any) => {
  if (inventory) return isAvailable(inventory);
  return false;
};

// Check if property is avaialble along with Inactive Check
export const isAvailable = (data: any) => {
  let flag = true;
  // Either if tag is mentioned
  if (data?.tags) {
    data.tags?.forEach((tag: string) => {
      if (tag == "not_available") {
        flag = false;
      }
    });
  }
  // if inventory is not available
  if (data?.available === false) {
    flag = false;
  }

  // Otherwise if its inactive (only for parent)
  if (data?.parent_id == null && data?.status == "inactive") {
    flag = false;
  }
  return flag;
};

export const getLeadDataForEvent = ({
  email_id,
  phone,
  country_code,
  source,
  canonical_name,
  leadId,
}: any) => ({
  email_id,
  phone,
  country_code,
  canonical_name,
  lead_id: leadId,
  ...(source && { lead_cta: source }),
});

export const fireLeadFormOneSuccessEvents = async ({
  email_id,
  phone,
  country_code,
  response,
  canonical_name = "",
  inventory,
  openingSource,
  isPartner,
  preferredCommunicationModes = [],
  ...rest
}: any) => {
  await identifyPostHogUserByEmail(email_id, {
    funnel: "lead",
    lead_id: response?.data?.id,
    phone,
    country_code,
    opening_source: openingSource,
    is_partner: isPartner,
    // Slug, name and timestamp move together or not at all.
    //
    // Person properties persist, so stamping the timestamp on its own is not a
    // harmless extra field: someone who enquired about property X last month
    // and now submits a lead with no inventory would keep `lead_property: X`
    // and get a fresh `lead_property_at`. "Enquired about a property in the
    // last N days" would then match them and deep-link to X, which they did
    // not just enquire about.
    ...(() => {
      const property = inventory?.canonical_name || canonical_name;
      if (!property) return {};
      // The inventory often has no name; reuse the one recorded for this slug.
      const displayName = inventory?.name || getRecordedPropertyNameForPostHog(property);
      return {
        lead_property: property,
        ...(displayName ? { lead_property_name: displayName } : {}),
        lead_property_at: new Date().toISOString(),
      };
    })(),
    // The lead response carries a user id when one was created, so a guest who
    // never logs in still gets one onto the PostHog person.
    ...(response?.data?.user_id ? { user_id: String(response.data.user_id) } : {}),
  });

  uetEventEmitter({ action: "lead_form_submit", category: "lead_form" });
  uetEventEmitterForChina({
    leadEmail: email_id,
    leadPhoneNumber: phone,
  });

  logAppEvent({
    eventName: APP_EVENTS.LEAD_CREATED,
    payload: {
      category: "Property Search",
      property_id: inventory?.id,
      lead_id: response.data.id,
      canonical_name: inventory?.canonical_name,
      property_name: inventory?.name,
      lead_created_from: openingSource,
      is_mobile_app_lead: "yes",
      email: email_id,
      phone,
    },
  });
  logMetaEvent(META_EVENT_CONSTANTS?.SUBMIT_LEAD_FORM, {
    property_id: inventory?.id,
    property_name: inventory?.name,
    currency: getPricingCurrencyStandardName(inventory?.pricing?.currency),
    value: getAvailableStartingPricingHelper(inventory?.pricing),
  });
  // Google Analytics
  gtagEventEmitter({
    action: "success",
    category: "lead",
    ...("flag" in rest ? { flag: rest.flag } : {}),
    ...(rest.location ? { location: rest.location } : {}),
    ...(rest.propertyName ? { propertyName: rest.propertyName } : {}),
    ...getLeadDataForEvent({
      email_id,
      phone,
      country_code,
      source: isPartner
        ? "partner_lead_form"
        : CTA_SOURCE_MAPPING[openingSource] || "Get_Help_Lead_CTA",
      canonical_name: inventory?.canonical_name ?? canonical_name,
      leadId: response.data.id,
    }),
    is_email_comms_opted: preferredCommunicationModes.includes("Email"),
    is_call_comms_opted: preferredCommunicationModes.includes("Call"),
    is_whatsapp_comms_opted:
      preferredCommunicationModes.includes("Whatsapp") ||
      preferredCommunicationModes.includes("Wechat"),
  });

  gtagDuplicateEventEmitter({
    action: "success_newleadform",
    category: "lead",
    ...("flag" in rest ? { flag: rest.flag } : {}),
    ...(rest.location ? { location: rest.location } : {}),
    ...(rest.propertyName ? { propertyName: rest.propertyName } : {}),
    ...getLeadDataForEvent({
      email_id,
      phone,
      country_code,
      source: isPartner
        ? "partner_lead_form"
        : CTA_SOURCE_MAPPING[openingSource] || "Get_Help_Lead_CTA",
      canonical_name: inventory?.canonical_name ?? canonical_name,
      leadId: response.data.id,
    }),
  });

  gtagDuplicateEventEmitter({
    action: "add_to_cart",
    value: `${getAvailableStartingPricingHelper(inventory?.pricing)}`,
    items: [
      {
        id: `${inventory?.id}`,
        google_business_vertical: "hotel_rental",
      },
    ],
  });

  // Tiktok Pixel Lead Form Event
  if (typeof window !== "undefined" && window.ttq) {
    window.ttq.track("SubmitForm");
  }

  if (typeof window !== "undefined" && window.rdt) {
    window.rdt("track", "Lead");
  }

  // OpenAI Pixel lead conversion
  if (typeof window !== "undefined" && window.oaiq) {
    window.oaiq("measure", "lead_created", { type: "customer_action" });
  }

  // TrafficGuard conversion
  // if (typeof dataTrafficGuard !== "undefined") {
  //   trafficGuardEventEmitter("lead");
  // }

  // Facebook conversion

  if (typeof fbq !== "undefined" && fbq !== null) {
    // standard lead event
    const contentIds = inventory?.id ? [inventory.id.toString()] : undefined;
    fbq("track", "Lead", contentIds ? { content_ids: contentIds } : {}, {
      eventID: response?.data?.uuid,
    });
  }

  // Quora Conversion
  if (typeof qp !== "undefined" && qp !== null) qp("track", "Generic");
  if (typeof snaptr !== "undefined" && snaptr !== null) {
    // reinitialize snapchat to set lead-from email
    snaptr("init", config.snapchat_event_id, {
      user_email: email_id,
    });
    snaptr("track", "SIGN_UP");
  }

  // wechat conversion
  if (typeof gdt !== "undefined" && gdt !== null) {
    gdt("track", "RESERVATION");
  }

  // Douyin Conversion
  if (typeof _baq !== "undefined" && _baq !== null) {
    _baq.track("form", { lead_id: response.data.id });
  }
};

export const handleLeadSuccessEvents = async ({
  email,
  phone,
  leadId,
  canonicalName,
  countryCode,
  flag = false,
  location,
  propertyName,
}: any) => {
  // adding delay to fire all events

  await sleep(20);
  const isMiniProgram = isMiniProgramUserAgent();

  if (!isMiniProgram) {
    handleLeadConversionEvent({ email, phone });
  }

  await sleep(50);
  gtagEventEmitter({
    action: "clicked_continue_booking",
    category: "",
    lead_id: leadId,
    canonical_name: canonicalName,
    email_id: email,
    phone,
    country_code: countryCode,
    lead_cta: "Continue Booking",
    flag,
    location,
    propertyName,
  });
};

export const handleLeadConversionEvent = ({ email, phone }: any) => {
  identifyPostHogUserByEmail(email, {
    funnel: "lead",
    phone,
  });

  if (typeof window !== "undefined" && !!window.dataLayer) {
    window.dataLayer.push({
      email,
      phone_number: phone,
    });
  }

  if (typeof gtag !== "undefined") {
    gtag("event", "conversion", { send_to: "AW-614642990/4nogCPq6k90YEK7qiqUC" });
  }
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getPropertyPageURL = (inventory: any) => {
  const { canonical_name } = inventory;
  const path = `/places/${canonical_name}#room_type`;
  return urlBuilder(path);
};
